import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {InventoryTransactionLineFactContainerModel} from '../../../../../../models/aggregates/erp/inventory-transaction-line-fact';
import {Core2Config} from '../../shared';
import {ApiVisa} from '../../shared/api-visa.model';
import {ApiResponseModel} from '../../shared/api-response.model';
import { InventoryTransactionLineFactCriteriaModelQuery, InventoryTransactionLineFactQueryCriteriaClass } from '../../../criteria/inventory-transaction-line-fact-criteria.model';

@Injectable({
  providedIn: 'root'
})
export class InventoryTransactionLineFactService extends BaseApiTemplateService<InventoryTransactionLineFactContainerModel> {
  readonly url =
    Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-line-fact-transactions';

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-line-fact-transactions';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-line-fact-transactions';
    this.httpClient = http;
  }

  getPromiseByCriteria(
    visa: ApiVisa, criteria?: InventoryTransactionLineFactQueryCriteriaClass
  ): Promise<ApiResponseModel<InventoryTransactionLineFactContainerModel>> {
    const buildDocCriteria = new InventoryTransactionLineFactCriteriaModelQuery(criteria);
    console.log('OverRide: ', buildDocCriteria.query);
    this.apiUrl = visa.api_domain_url + this.endpoint_path + '/query?' + buildDocCriteria.query;
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    console.log('UrlByCriteria: ', UrlByCriteria);
    return this.httpClient.get<ApiResponseModel<InventoryTransactionLineFactContainerModel>>
    ( this.apiUrl, this.getHttpHeader(visa))
      .toPromise();
  }
  
}


